// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base styles for desktop and mobile */

/* Sidebar base styles */
.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: white;
  width: 250px;
  height: 100vh;
}

.sidebar-scroll {
  height: calc(90vh);
  overflow: auto;
}

/* Sidebar items */
.sidebar-list-items {
  margin: 0;
  padding: 0;
}

.sidebar-list-item {
  list-style-type: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 14px;
  padding: 10px 15px; /* Added padding for better visibility */
}

.sidebar-list-item:hover {
  background-color: #f0f0f0; /* Hover color */
  border-radius: 6px 0 0 6px;
}

.sidebar-list-item.selected {
  background-color: rgb(0, 123, 255) !important;
  color: white !important;
  border-radius: 6px 0 0 6px;
}

/* Nav item styling */
.nav-item {
  font-size: 15px;
  color: black !important;
  font-family: Poppins;
  text-decoration: none; /* Ensures links are visible */
}

/* Responsive styling for mobile */
.mobile-sidebar-container {
  position: relative;
}

.sidebar-toggle {
  display: block;
  position: fixed;
  top: 10px;
  left: 10px;
  font-size: 24px;
  background: none;
  border: none;
  z-index: 100;
  cursor: pointer;
}

.sidebar-close {
  display: block;
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 24px;
  background: none;
  border: none;
  cursor: pointer;
}

/* Mobile-specific adjustments */
@media (max-width: 844px) {
  .sidebar {
    width: 200px;
    transform: translateX(-100%);
    transition: transform 0.3s ease-in-out;
  }

  .sidebar.open {
    transform: translateX(0);
  }

  .sidebar-toggle,
  .sidebar-close {
    display: block;
  }

  .sidebar-list-item {
    font-size: 16px; /* Increase font size for better readability */
    padding: 12px 20px; /* Add padding for mobile */
  }

  .nav-item {
    color: black !important; /* Ensure text color is always black */
  }

  .sidebar-list-item.selected .nav-item {
    color: white !important; /* Ensure text color is white when selected */
  }
}

@media (min-width: 601px) {
  .sidebar-toggle,
  .sidebar-close {
    display: none;
  }
}


.sidebat-text{
  color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/components/SidebarV2/styles.css"],"names":[],"mappings":"AAAA,uCAAuC;;AAEvC,wBAAwB;AACxB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,kBAAkB,EAAE,wCAAwC;AAC9D;;AAEA;EACE,yBAAyB,EAAE,gBAAgB;EAC3C,0BAA0B;AAC5B;;AAEA;EACE,6CAA6C;EAC7C,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB,EAAE,8BAA8B;AACvD;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE;IACE,YAAY;IACZ,4BAA4B;IAC5B,sCAAsC;EACxC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,eAAe,EAAE,8CAA8C;IAC/D,kBAAkB,EAAE,2BAA2B;EACjD;;EAEA;IACE,uBAAuB,EAAE,sCAAsC;EACjE;;EAEA;IACE,uBAAuB,EAAE,6CAA6C;EACxE;AACF;;AAEA;EACE;;IAEE,aAAa;EACf;AACF;;;AAGA;EACE,uBAAuB;AACzB","sourcesContent":["/* Base styles for desktop and mobile */\n\n/* Sidebar base styles */\n.sidebar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  background-color: white;\n  width: 250px;\n  height: 100vh;\n}\n\n.sidebar-scroll {\n  height: calc(90vh);\n  overflow: auto;\n}\n\n/* Sidebar items */\n.sidebar-list-items {\n  margin: 0;\n  padding: 0;\n}\n\n.sidebar-list-item {\n  list-style-type: none;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  font-size: 14px;\n  padding: 10px 15px; /* Added padding for better visibility */\n}\n\n.sidebar-list-item:hover {\n  background-color: #f0f0f0; /* Hover color */\n  border-radius: 6px 0 0 6px;\n}\n\n.sidebar-list-item.selected {\n  background-color: rgb(0, 123, 255) !important;\n  color: white !important;\n  border-radius: 6px 0 0 6px;\n}\n\n/* Nav item styling */\n.nav-item {\n  font-size: 15px;\n  color: black !important;\n  font-family: Poppins;\n  text-decoration: none; /* Ensures links are visible */\n}\n\n/* Responsive styling for mobile */\n.mobile-sidebar-container {\n  position: relative;\n}\n\n.sidebar-toggle {\n  display: block;\n  position: fixed;\n  top: 10px;\n  left: 10px;\n  font-size: 24px;\n  background: none;\n  border: none;\n  z-index: 100;\n  cursor: pointer;\n}\n\n.sidebar-close {\n  display: block;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 24px;\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n\n/* Mobile-specific adjustments */\n@media (max-width: 844px) {\n  .sidebar {\n    width: 200px;\n    transform: translateX(-100%);\n    transition: transform 0.3s ease-in-out;\n  }\n\n  .sidebar.open {\n    transform: translateX(0);\n  }\n\n  .sidebar-toggle,\n  .sidebar-close {\n    display: block;\n  }\n\n  .sidebar-list-item {\n    font-size: 16px; /* Increase font size for better readability */\n    padding: 12px 20px; /* Add padding for mobile */\n  }\n\n  .nav-item {\n    color: black !important; /* Ensure text color is always black */\n  }\n\n  .sidebar-list-item.selected .nav-item {\n    color: white !important; /* Ensure text color is white when selected */\n  }\n}\n\n@media (min-width: 601px) {\n  .sidebar-toggle,\n  .sidebar-close {\n    display: none;\n  }\n}\n\n\n.sidebat-text{\n  color: white !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
